import "@/App.css";
import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";

const ZakatCalculatorPage = lazy(() => import("@/pages/ZakatCalculator"));
const Privacy = lazy(() => import("@/pages/Privacy"));
const AdminLogin = lazy(() => import("@/pages/AdminLogin"));
const AdminPanel = lazy(() => import("@/pages/AdminPanel"));

function App() {
    return (
        <BrowserRouter>
            <Layout>
                <Suspense fallback={<div className="py-24" />}>
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/zakat" element={<ZakatCalculatorPage />} />
                        <Route path="/privacy" element={<Privacy />} />
                        <Route path="/admin/login" element={<AdminLogin />} />
                        <Route path="/admin" element={<AdminPanel />} />
                        <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                </Suspense>
            </Layout>
            <Toaster position="top-center" dir="rtl" richColors />
        </BrowserRouter>
    );
}

export default App;
